import AppRoutes from "../../routes";
import Theme from "../Theme/Theme";

const App = () => {
  return (
    <Theme>
      <AppRoutes />
    </Theme>
  );
};

export default App;
